












































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CreateFeeRequest from '@/models/Accounts/Shared/Fees/CreateFeeRequest';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';

@Component({ name: 'FeeManualForm' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    request: CreateFeeRequest;

    @Prop({required: true})
    currency: string;

    get subTransactionTypes() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

}
